document.addEventListener('DOMContentLoaded', function () {
  var cards = document.querySelectorAll('.card');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          setTimeout(function () {
            entry.target.classList.add('in-view');
          }, i * 60);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    cards.forEach(function (c) { observer.observe(c); });
  } else {
    cards.forEach(function (c) { c.classList.add('in-view'); });
  }

  var toggle = document.querySelector('.nav-toggle');
  var links = document.querySelector('nav .links');
  if (toggle && links) {
    toggle.addEventListener('click', function () {
      links.classList.toggle('mobile-open');
    });
  }

  var genderButtons = document.querySelectorAll('[data-gender-btn]');
  genderButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var gender = btn.getAttribute('data-gender-btn');
      document.body.classList.toggle('show-women', gender === 'women');
      genderButtons.forEach(function (b) { b.classList.remove('active'); });
      document.querySelectorAll('[data-gender-btn="' + gender + '"]').forEach(function (b) {
        b.classList.add('active');
      });
    });
  });
});
